export class ConceptInvoicingModel {
  conceptInvoicingId: number = 0;
  conceptInvoicingType: number = 0;
  companyId: number = 0;
  code: number = 0;
  alterCode: string | null = null;
  alterCode2: string | null = null;
  name: string = '';
  cxcConcept: string | null = null;
  affectsInventory: boolean | null = null;
  promptPayment: boolean | null = null;
  conceptInvoicingPriceOfId: number = 0;
  swDispersedFamily: boolean = false;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
